import { v4 as uuid } from "uuid";

import type {
	AlertData,
	AlertDataPayload,
	AlertLoadingData
} from "~/common/interfaces/alert-data.interface";

export const useAlertStore = defineStore("alert", () => {
	const alerts = ref<AlertData[]>([]);
	const loadingAlerts = ref<AlertLoadingData[]>([]);

	const getLatestUnreadAlert = computed(() => {
		return alerts.value.filter(alert => alert.unread).reverse().slice(0, 6);
	});

	const addAlert = (alertDataPayload: AlertDataPayload) => {
		const description = Array.isArray(alertDataPayload.description)
			? alertDataPayload.description
			: [alertDataPayload.description];
		const sanitizedDescription = description.join(".\n");
		alerts.value.unshift({
			id: uuid(),
			...alertDataPayload,
			description: sanitizedDescription,
			unread: true
		});
	};
	const createLoadingAlert = () => {
		const id = uuid();
		loadingAlerts.value.push({
			id,
			title: ""
		});

		return id;
	};
	const updateLoadingAlert = (alertLoadingData: AlertLoadingData) => {
		const loadingAlert = loadingAlerts.value.find(alert => alert.id === alertLoadingData.id);
		if (!loadingAlert) { return; }

		loadingAlert.title = alertLoadingData.title;
	};
	const removeLoadingAlert = (id: string) => {
		loadingAlerts.value = loadingAlerts.value.filter(alert => alert.id !== id);
	};

	return {
		alerts,
		loadingAlerts,

		getLatestUnreadAlert,
		createLoadingAlert,
		updateLoadingAlert,
		removeLoadingAlert,

		addAlert
	};
});
